import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
// import { useDispatch } from 'react-redux';
// import { buscaImage } from '../../../redux/actions/fotoActions';

const StyledImg = styled.img`
    width: ${props => props.width};
    height: ${props => props.height};
    cursor: ${({ cursor }) => cursor};
`;

// Component Core
const Image = withTheme(({ src, height, width, ...props }) => {
    return (
        <>
            {src ? (
                <StyledImg src={src} height={height} width={width} {...props} />
            ) : (
                <div
                    style={{
                        height,
                        width
                    }}
                >
                    <CircularProgress size={height / 2} />
                </div>
            )}
        </>
    );
});

// Component Props
Image.propTypes = {
    title: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    src: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Image.defaultProps = {
    src: undefined,
    width: '100%',
    height: 'auto'
};

export { Image };
